import { formatDateYYYYMMDD } from "../helpers/utils";
import { Product } from "./product";

export interface PackagedProduct extends Product {
  packagingDescription: string;
  quantityPackaging: number;
  quantityPackagingUnitID: string;  
}

export interface InvoiceProduct extends PackagedProduct {
    id: string;
    packagingID: string;
    quantity: number;
    quantityQuantity: number;
    quantityUnitID: string;
    unitPrice: number;
    quantityPriced: number;
    quantityPricedUnitID: string;
    vatRate: number;
    totalPriceHT: number;
    totalPriceTTC: number;
    isDirty: boolean;
    deliveryNoteNumber: string;
}

export interface Invoice  {
    invoiceID: string | null;
    supplierName: string;
    invoiceNumber: string;
    invoiceDate: string ;
    deliveryDate: string | undefined;   //TODO: change to Date
    dueDate: string | undefined;
    paymentDate: string | undefined;
    paymentMode: string;
    farmID: string;
    farmName: string;
    products: InvoiceProduct[];
    isDirty: boolean;
    totalPriceHT?: number;
    totalPriceTTC?: number;
  }

export interface Invoices {
    invoices: Invoice[];
    editedInvoice: Invoice;
}


export const blankInvoice: Invoice = {
    invoiceID: null,
    supplierName: '',
    invoiceNumber: '',
    invoiceDate: formatDateYYYYMMDD(new Date()) || '',
    deliveryDate: undefined,
    dueDate: undefined,
    paymentDate: undefined,
    paymentMode: '',
    farmName: '',
    farmID: '',
    products: [],
    isDirty: true,
    totalPriceHT: 0,
    totalPriceTTC: 0
  };

  export const blankInvoiceProduct: InvoiceProduct = {
    id: '',
    productID:  '',
    productName : '',
    packagingDescription : '',
    quantityPackaging : 1,
    quantityPackagingUnitID : '',
    quantity : 0,
    quantityQuantity : 0,
    quantityPriced : 1,
    unitPrice : 0,
    vatRate : 0,
    totalPriceHT : 0,
    totalPriceTTC : 0,
    isDirty: true,
    packagingID: '99bd2babaa4411ffa4020252ac141402',
    forFertigation: false,
    deliveryNoteNumber: '' ,
    quantityUnitID: '',
    quantityPricedUnitID: ''
};